import { useSyncExternalStore } from 'react';

// Module-level counter that anything mutating transactions can bump so the
// budget-actuals hook (which derives from the same `/api/transactions`
// endpoint via `aggregate=totals`) knows to refetch. Without this, editing a
// transaction's category on the Transactions tab and then switching to the
// Budget tab shows stale totals until a page refresh — both hooks fetch
// independently and don't share a cache.

let version = 0;
const listeners = new Set<() => void>();

export function bumpActualsVersion(): void {
  version++;
  for (const l of listeners) l();
}

function subscribe(callback: () => void): () => void {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

export function useActualsVersion(): number {
  return useSyncExternalStore(
    subscribe,
    () => version,
    () => 0,
  );
}
